import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"


const NotFound = () => {
    //Redireccionamiento de la página útil para usarlo cuando se recarga la aplicación o se quiere abrir la aplicación desde una pantalla especificada en el link en específico 
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const rutaOriginal = queryParams.get('rutaOriginal');
    const pathName = location.pathname

    const navigate = useNavigate()
    
    useEffect(() =>{
        if(pathName.includes("App/App/")){
            navigate(pathName.replace("App/App/", "App/"))
        }
        if(rutaOriginal && rutaOriginal !== "home"){
            navigate(`/${rutaOriginal}`)
        }else{
            navigate("/home")
        }
    },[])

    //Por Ahora solo redirige a home y nos redirecciona a algun sitio, pero se podría dejar un mensaje personalizado
    return(
    <>

    </>
    )
}


export default NotFound